import { type FC, type Ref, type SVGProps } from "react";
import { cn } from "../Utilities";

import { ReactComponent as AlignLeft } from "./assets/align-left.svg";
import { ReactComponent as ArrowBottomRight } from "./assets/arrow-bottom-right.svg";
import { ReactComponent as ArrowCircleRight } from "./assets/arrow-circle-right.svg";
import { ReactComponent as ArrowDownRight } from "./assets/arrow-down-right.svg";
import { ReactComponent as ArrowDown } from "./assets/arrow-down.svg";
import { ReactComponent as ArrowDownload } from "./assets/arrow-download.svg";
import { ReactComponent as ArrowLeft } from "./assets/arrow-left.svg";
import { ReactComponent as ArrowRedo } from "./assets/arrow-redo.svg";
import { ReactComponent as ArrowRefresh } from "./assets/arrow-refresh.svg";
import { ReactComponent as ArrowRight } from "./assets/arrow-right.svg";
import { ReactComponent as ArrowSaving } from "./assets/arrow-saving.svg";
import { ReactComponent as ArrowTopRight } from "./assets/arrow-top-right.svg";
import { ReactComponent as ArrowUndo } from "./assets/arrow-undo.svg";
import { ReactComponent as ArrowUnfoldVertical } from "./assets/arrow-unfold-vertical.svg";
import { ReactComponent as ArrowUp } from "./assets/arrow-up.svg";
import { ReactComponent as ArrowUpload } from "./assets/arrow-upload.svg";
import { ReactComponent as ArrowUpload2 } from "./assets/arrow-upload2.svg";
import { ReactComponent as Bell } from "./assets/bell.svg";
import { ReactComponent as Brain } from "./assets/brain.svg";
import { ReactComponent as Building } from "./assets/building.svg";
import { ReactComponent as CalendarArrowUp } from "./assets/calendar-arrow-up.svg";
import { ReactComponent as Calendar } from "./assets/calendar.svg";
import { ReactComponent as CaretDown } from "./assets/caret-down.svg";
import { ReactComponent as CaretRight } from "./assets/caret-right.svg";
import { ReactComponent as Check } from "./assets/check.svg";
import { ReactComponent as ChevronDown } from "./assets/chevron-down.svg";
import { ReactComponent as ChevronLeft } from "./assets/chevron-left.svg";
import { ReactComponent as ChevronRight } from "./assets/chevron-right.svg";
import { ReactComponent as ChevronUpDown } from "./assets/chevron-up-down.svg";
import { ReactComponent as ChevronUp } from "./assets/chevron-up.svg";
import { ReactComponent as CircleBig } from "./assets/circle-big.svg";
import { ReactComponent as CircleCross } from "./assets/circle-cross.svg";
import { ReactComponent as CircleHelp } from "./assets/circle-help.svg";
import { ReactComponent as CircleInProgress } from "./assets/circle-in-progress.svg";
import { ReactComponent as CircleInfo } from "./assets/circle-info.svg";
import { ReactComponent as CircleLoading } from "./assets/circle-loading.svg";
import { ReactComponent as CirclePlus } from "./assets/circle-plus.svg";
import { ReactComponent as CircleTodo } from "./assets/circle-todo.svg";
import { ReactComponent as CircleValidated } from "./assets/circle-validated.svg";
import { ReactComponent as CircleWarning } from "./assets/circle-warning.svg";
import { ReactComponent as ClipboardCheck } from "./assets/clipboard-check.svg";
import { ReactComponent as ClipboardList } from "./assets/clipboard-list.svg";
import { ReactComponent as ClipboardPaste } from "./assets/clipboard-paste.svg";
import { ReactComponent as Close } from "./assets/close.svg";
import { ReactComponent as CloudWithValidateIcon } from "./assets/cloud-with-validate.svg";
import { ReactComponent as CommentPlus } from "./assets/comment-plus.svg";
import { ReactComponent as Comment } from "./assets/comment.svg";
import { ReactComponent as Company } from "./assets/company.svg";
import { ReactComponent as FlagFrance } from "./assets/countries/france.svg";
import { ReactComponent as FlagUK } from "./assets/countries/uk.svg";
import { ReactComponent as DashboardIcon } from "./assets/dashboard.svg";
import { ReactComponent as Document } from "./assets/document.svg";
import { ReactComponent as DoubleCheck } from "./assets/double-check.svg";
import { ReactComponent as Duplicate } from "./assets/duplicate.svg";
import { ReactComponent as EcoVadis } from "./assets/ecovadis.svg";
import { ReactComponent as Edit } from "./assets/edit.svg";
import { ReactComponent as Email } from "./assets/email.svg";
import { ReactComponent as External } from "./assets/external.svg";
import { ReactComponent as EyeOff } from "./assets/eye-off.svg";
import { ReactComponent as EyeOn } from "./assets/eye-on.svg";
import { ReactComponent as File } from "./assets/file.svg";
import { ReactComponent as Flag } from "./assets/flag.svg";
import { ReactComponent as Form } from "./assets/form.svg";
import { ReactComponent as Globe } from "./assets/globe.svg";
import { ReactComponent as GripVertical } from "./assets/grip-vertical.svg";
import { ReactComponent as Group } from "./assets/group.svg";
import { ReactComponent as Image } from "./assets/image.svg";
import { ReactComponent as Larger } from "./assets/larger.svg";
import { ReactComponent as Link } from "./assets/link.svg";
import { ReactComponent as ListChecksMulti } from "./assets/list-checks-multi.svg";
import { ReactComponent as ListChecksSingle } from "./assets/list-checks-single.svg";
import { ReactComponent as ListOrder } from "./assets/list-order.svg";
import { ReactComponent as List } from "./assets/list.svg";
import { ReactComponent as LoadData } from "./assets/load-data.svg";
import { ReactComponent as LoaderAnimated } from "./assets/loader-animated.svg";
import { ReactComponent as Loader } from "./assets/loader.svg";
import { ReactComponent as LoadingBeams } from "./assets/loading-beams.svg";
import { ReactComponent as Lock } from "./assets/lock.svg";
import { ReactComponent as Logo } from "./assets/logo.svg";
import { ReactComponent as MagicWand } from "./assets/magic-wand.svg";
import { ReactComponent as Megaphone } from "./assets/megaphone.svg";
import { ReactComponent as Minus } from "./assets/minus.svg";
import { ReactComponent as More } from "./assets/more.svg";
import { ReactComponent as Number } from "./assets/number.svg";
import { ReactComponent as Palette } from "./assets/palette.svg";
import { ReactComponent as PanelLeft } from "./assets/panel-left.svg";
import { ReactComponent as Paperclip } from "./assets/paperclip.svg";
import { ReactComponent as Party } from "./assets/party.svg";
import { ReactComponent as PencilCrossed } from "./assets/pencil-crossed.svg";
import { ReactComponent as Pilcrow } from "./assets/pilcrow.svg";
import { ReactComponent as Plus } from "./assets/plus.svg";
import { ReactComponent as Quote } from "./assets/quote.svg";
import { ReactComponent as Rocket } from "./assets/rocket.svg";
import { ReactComponent as Ruler } from "./assets/ruler.svg";
import { ReactComponent as Sale } from "./assets/sale.svg";
import { ReactComponent as Scale } from "./assets/scale.svg";
import { ReactComponent as Search } from "./assets/search.svg";
import { ReactComponent as Settings } from "./assets/settings.svg";
import { ReactComponent as Shorten } from "./assets/shorten.svg";
import { ReactComponent as SignOut } from "./assets/sign-out.svg";
import { ReactComponent as Stars } from "./assets/stars.svg";
import { ReactComponent as Stop } from "./assets/stop.svg";
import { ReactComponent as Table } from "./assets/table.svg";
import { ReactComponent as TagCircle } from "./assets/tag-circle.svg";
import { ReactComponent as TagEmptyCircle } from "./assets/tag-empty-circle.svg";
import { ReactComponent as Tag } from "./assets/tag.svg";
import { ReactComponent as Target } from "./assets/target.svg";
import { ReactComponent as Target2 } from "./assets/target2.svg";
import { ReactComponent as ThumbsDownFilled } from "./assets/thumbs-down-filled.svg";
import { ReactComponent as ThumbsDown } from "./assets/thumbs-down.svg";
import { ReactComponent as ThumbsUpFilled } from "./assets/thumbs-up-filled.svg";
import { ReactComponent as ThumbsUp } from "./assets/thumbs-up.svg";
import { ReactComponent as Translate } from "./assets/translate.svg";
import { ReactComponent as Trash } from "./assets/trash.svg";
import { ReactComponent as Type } from "./assets/type.svg";
import { ReactComponent as UserCheck } from "./assets/user-check.svg";
import { ReactComponent as UserDelete } from "./assets/user-delete.svg";
import { ReactComponent as UserPlus } from "./assets/user-plus.svg";
import { ReactComponent as User } from "./assets/user.svg";
import { ReactComponent as Users } from "./assets/users.svg";
import { ReactComponent as Validate } from "./assets/validate.svg";
import { ReactComponent as Video } from "./assets/video.svg";
import { ReactComponent as Warning } from "./assets/warning.svg";

export const iconMap = {
    alignLeft: AlignLeft,
    arrowBottomRight: ArrowBottomRight,
    arrowCircleRight: ArrowCircleRight,
    arrowDown: ArrowDown,
    arrowDownload: ArrowDownload,
    arrowDownRight: ArrowDownRight,
    arrowLeft: ArrowLeft,
    arrowRedo: ArrowRedo,
    arrowRefresh: ArrowRefresh,
    arrowRight: ArrowRight,
    arrowTopRight: ArrowTopRight,
    arrowUndo: ArrowUndo,
    arrowUnfoldVertical: ArrowUnfoldVertical,
    arrowUp: ArrowUp,
    arrowUpload: ArrowUpload,
    arrowUpload2: ArrowUpload2,
    arrowSaving: ArrowSaving,
    bell: Bell,
    brain: Brain,
    building: Building,
    calendar: Calendar,
    calendarArrowUp: CalendarArrowUp,
    caretDown: CaretDown,
    caretRight: CaretRight,
    check: Check,
    chevronDown: ChevronDown,
    chevronLeft: ChevronLeft,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    chevronUpDown: ChevronUpDown,
    circleBig: CircleBig,
    circleCross: CircleCross,
    circleHelp: CircleHelp,
    circleInProgress: CircleInProgress,
    circleInfo: CircleInfo,
    circleLoading: CircleLoading,
    circlePlus: CirclePlus,
    circleTodo: CircleTodo,
    circleValidated: CircleValidated,
    circleWarning: CircleWarning,
    clipboardCheck: ClipboardCheck,
    clipboardList: ClipboardList,
    clipboardPaste: ClipboardPaste,
    close: Close,
    cloudWithValidate: CloudWithValidateIcon,
    comment: Comment,
    commentPlus: CommentPlus,
    company: Company,
    dashboard: DashboardIcon,
    document: Document,
    doubleCheck: DoubleCheck,
    duplicate: Duplicate,
    ecoVadis: EcoVadis,
    edit: Edit,
    editCrossed: PencilCrossed,
    email: Email,
    external: External,
    eyeOff: EyeOff,
    eyeOn: EyeOn,
    file: File,
    flag: Flag,
    form: Form,
    globe: Globe,
    gripVertical: GripVertical,
    group: Group,
    image: Image,
    larger: Larger,
    link: Link,
    list: List,
    listChecksMulti: ListChecksMulti,
    listChecksSingle: ListChecksSingle,
    listOrder: ListOrder,
    loadData: LoadData,
    loader: Loader,
    loaderAnimated: LoaderAnimated,
    loadingBeams: LoadingBeams,
    lock: Lock,
    logo: Logo,
    magicWand: MagicWand,
    megaphone: Megaphone,
    minus: Minus,
    more: More,
    number: Number,
    palette: Palette,
    paperclip: Paperclip,
    panelLeft: PanelLeft,
    party: Party,
    pilcrow: Pilcrow,
    plus: Plus,
    quote: Quote,
    rocket: Rocket,
    ruler: Ruler,
    sale: Sale,
    scale: Scale,
    search: Search,
    settings: Settings,
    shorten: Shorten,
    signOut: SignOut,
    stars: Stars,
    stop: Stop,
    table: Table,
    tag: Tag,
    tagCircle: TagCircle,
    tagEmptyCircle: TagEmptyCircle,
    target: Target,
    target2: Target2,
    thumbsDownFilled: ThumbsDownFilled,
    thumbsDown: ThumbsDown,
    thumbsUpFilled: ThumbsUpFilled,
    thumbsUp: ThumbsUp,
    translate: Translate,
    trash: Trash,
    type: Type,
    user: User,
    userCheck: UserCheck,
    userDelete: UserDelete,
    userPlus: UserPlus,
    users: Users,
    validate: Validate,
    video: Video,
    warning: Warning,

    // flags
    fr: FlagFrance,
    uk: FlagUK,
} as const;

export type IconName = keyof typeof iconMap;

export interface IconProps extends SVGProps<SVGSVGElement> {
    name: IconName;
    size?: "xs" | "sm" | "md" | "lg";
    ref?: Ref<SVGSVGElement>;
}

export const Icon: FC<IconProps> = ({
    name,
    size,
    className,
    ref,
    ...props
}) => {
    const Comp = iconMap[name];

    // compute width and height based on size prop
    const sizeTw =
        size === "xs"
            ? "w-3 h-3"
            : size === "sm"
              ? "w-4 h-4"
              : size === "lg"
                ? "w-6 h-6"
                : "w-5 h-5"; // md is also the default size
    return (
        <Comp
            ref={ref}
            className={cn(sizeTw, "shrink-0", className)}
            {...props}
        />
    );
};
